import BaseModelService from '../../base/base_model_service.js';
import _ from '../../utils/underscore';
import * as RegulationConst from './regulation_const';


/**
 *
 *
 *
 */
class RegulationModel extends BaseModelService {

    /**
     * @static
     * @type {string}
     */
    static CLASS = 'RegulationModel';


    /**
     *
     * @param params
     */
    init(params) {
        if (params) {
            this
                ._setRegulationCode(params.code)
                ._setReminderIntervals(params)
                ._setTimeLimitPercentageReminder(params)
                ._setMaxDurationsInMinutesForMobile(params)
                ._setMaxDurationsInMinutesForPC(params)
                ._setLossLimitPercentages(params)
                ._setIntervalReminderInMinutes(params)
                ._setRestrictionPeriodsInMinutes(params)
                ._setSessionCooldownConfigData(params);
        }
    }


    /**
     * Set the regulation code as an private property.
     *
     * @param code
     * @returns {RegulationModel}
     * @private
     */
    _setRegulationCode(code) {
        this._regulationCode =  RegulationConst.REGULATION_CODE_TYPES[code] || "UK";
        return this;
    }

    _reminderIntervals = [];

    _setReminderIntervals(params) {

        this._reminderIntervals = this._splitCommaSeparatedNumbers(params.reminderIntervals);

        return this;
    }

	_setTimeLimitPercentageReminder(params) {

        let value = this._extractRegulationSpecificConfig(params, 'TimeLimitPercentageReminder');

        if (!_.isNullOrUndefined(value)) {
            this._timeLimitPercentageReminder = value / 100;
        }

        return this;
    }

    _splitCommaSeparatedNumbers(commaSeparatedNumbers) {
        if(_.isNullOrUndefined(commaSeparatedNumbers)) {
            return null;
        }
        return commaSeparatedNumbers.split(',')
                                    .map(n => n.trim())
                                    .filter(n => n !== '')
                                    .map(n => n * 1)
    }

    _setMaxDurationsInMinutesForMobile(params) {
        this._maxDurationsInMinutesForMobile = this._splitCommaSeparatedNumbers(this._extractRegulationSpecificConfig(params, 'MaxDurationsInMinutesForMobile'));
        return this;
    }

    getMaxDurationsInMinutesForMobile() {
        return this._maxDurationsInMinutesForMobile;
    }

    _setMaxDurationsInMinutesForPC(params) {
        this._maxDurationsInMinutesForPC = this._splitCommaSeparatedNumbers(this._extractRegulationSpecificConfig(params, 'MaxDurationsInMinutesForPC'));
        return this;
    }

    getMaxDurationsInMinutesForPC() {
        return this._maxDurationsInMinutesForPC;
    }


    _setLossLimitPercentages(params) {
        this._lossLimitPercentages = this._splitCommaSeparatedNumbers(this._extractRegulationSpecificConfig(params, 'LossLimitPercentages'));
        return this;
    }

    getLossLimitPercentages() {
        return this._lossLimitPercentages;
    }

    _setIntervalReminderInMinutes(params) {
        this._intervalReminderInMinutes = this._splitCommaSeparatedNumbers(this._extractRegulationSpecificConfig(params, 'IntervalReminderInMinutes'));
        return this;
    }

    getIntervalReminderInMinutes() {
        return this._intervalReminderInMinutes;
    }

    _setRestrictionPeriodsInMinutes(params) {
        this._restrictionPeriodsInMinutes = this._splitCommaSeparatedNumbers(this._extractRegulationSpecificConfig(params, 'RestrictionPeriodsInMinutes'));
        return this;
    }

    getRestrictionPeriodsInMinutes() {
        return this._restrictionPeriodsInMinutes;
    }

    _setSessionCooldownConfigData(params) {
        this._sessionCooldownConfig = {
            cooldownTime: params.sessionCooldownTime || "00:00:00"
        };
        return this;
    }

    getSessionCooldownConfigData() {
        return this._sessionCooldownConfig;
    }

    _extractRegulationSpecificConfig(params, configName) {
        let regulationCode = RegulationConst.REGULATION_CODE_TYPES[params.code] || RegulationConst.REGULATION_CODE_TYPES['SPAIN'];
        let regulationParams = params[RegulationConst.REGULATION_NAMES[regulationCode]];

        if (_.isNullOrUndefined(regulationParams)) {
            return null;
        }

        return regulationParams[configName];
    }


	getTimeLimitPercentageReminder() {
        return this._timeLimitPercentageReminder;
    }

    /**
     * Get the sequence combination for the current regulation.
     *
     * @returns {*}
     * @public
     */
    getSequence(type, regulation) {
        type = type.toUpperCase();

        return this._sequences[type] && this._sequences[type][regulation];
    }

    /**
     *
     * @returns (string)
     * @public
     */
    getReminderIntervals() {
        return this._reminderIntervals;
    }

}
export default RegulationModel;